import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import IosSwitch from "../../components/iosSwitch";
import {
  useChangeEmployeeStatusMutation,
  useLazyGetEmployeeDetailsQuery,
} from "../../service/employee";
import { showError, showToast } from "../../constants/toasts";
import { Members } from "../../types/General";
import dayjs from "dayjs";
import Loader from "../../constants/Loader";

const ViewEmployee = () => {
  const navigate = useNavigate();
  const [changeStatus] = useChangeEmployeeStatusMutation();
  const [getEmployee] = useLazyGetEmployeeDetailsQuery();

  const { id } = useParams();
  const [reason, setReason] = useState("");
  const [checked, setChecked] = React.useState(true);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [employeeData, setEmployeeData] = useState<Members>();
  const handleCloseModal = () => {
    setOpen(false);
  };

  const goBack = () => {
    navigate(-1);
  };

  const getEmployeeDetail = async () => {
    setLoading(true);
    try {
      const response = await getEmployee({
        id,
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setEmployeeData(response?.data);
        setChecked(response?.data?.isActive === "Active" ? true : false);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const handleStatusChange = async (status: any) => {
    const body = {
      userId: id,
      userStatus: status,
    };

    try {
      const response = await changeStatus(body).unwrap();
      if (response?.status === 200) {
        if (status === "Inactive") {
          showToast("Blocked successfully");
        } else {
          showToast("Unblocked successfully");
        }
        getEmployeeDetail();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.error(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getEmployeeDetail();
  }, []);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            Employee Detail
          </h1>
        </div>

        <div className="cards view_page">
          <div className="profile_bx  mb_30">
            <div className="profile_dtl">
              <figure>
                <img
                  src={
                    employeeData
                      ? employeeData?.profileImage
                      : "/static/images/user_placeholder.png"
                  }
                  alt="profile img"
                />
              </figure>
              <div className="profile_cnt">
                <h2>{employeeData?.name || "-"}</h2>
                <p>
                  {" "}
                  <a>
                    {" "}
                    <IconButton>
                      <img src="/static/images/email_icon.svg" alt="icon" />
                    </IconButton>{" "}
                    {employeeData?.email || "-"}
                  </a>
                </p>
                <p>
                  {" "}
                  <a>
                    {" "}
                    <IconButton>
                      <img src="/static/images/call_icon.svg" alt="icon" />
                    </IconButton>{" "}
                    {`${employeeData?.phoneNumber?.countryCode || ""} ${employeeData?.phoneNumber?.phone || "-"}`}
                  </a>
                </p>
              </div>
            </div>
            <div className="rt">
              <IosSwitch
                checked={checked}
                setChecked={setChecked}
                onStatusChange={(newStatus) => handleStatusChange(newStatus)}
              />
              <Button
                className="btn btn_primary"
                onClick={() => navigate(`/manage-employee/edit/${id}`)}
              >
                {" "}
                <img src="/static/images/edit_icon.svg" alt="icon" /> Edit
                Details
              </Button>
            </div>
          </div>

          <div className="section_title">
            <h2>Membership Type</h2>
          </div>

          <div className="gap_p ">
            <div className="w_25">
              <h6>Birthday</h6>
              <p>{dayjs(employeeData?.dateOfBirth).format("DD MMMM , YYYY")}</p>
            </div>
            <div className="w_25">
              <h6>Gender</h6>
              <p>{employeeData?.gender || "-"}</p>
            </div>
          </div>
        </div>
      </MainContainer>

      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        onClick={() => setOpen(false)}
        setReason={setReason}
        reason={reason}
      />
    </>
  );
};

export default ViewEmployee;
